import { gql } from '@apollo/client';

export const GET_USER_BY_ID_V3 = gql`
  query userByIdV3($id: ID!) {
    userByIdV3(id: $id) {
      id
      name
      firstName
      lastName
      email
      membershipsV2 {
        organisation
        rolesWithName {
          id
          name
        }
      }
    }
  }
`;
